/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Autonomous_Trigger_Detector_DefectInputs */



/**
* | output |
* | --- |
* | "ATD fault" |
*
* @param {Autonomous_Trigger_Detector_DefectInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const autonomous_trigger_detector_defect = /** @type {((inputs?: Autonomous_Trigger_Detector_DefectInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Autonomous_Trigger_Detector_DefectInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("ATD fault")
	return /** @type {LocalizedString} */ ("Défaut DAD")
});